import { render, staticRenderFns } from "./StudentSupportContacts.vue?vue&type=template&id=354da187"
import script from "./StudentSupportContacts.vue?vue&type=script&lang=js"
export * from "./StudentSupportContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports